var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    [
      _vm.$wf.isSmDown
        ? _c(
            "app-toolbar",
            [
              _c(
                "w-toolbar-item",
                {
                  attrs: { disabled: _vm.saveDisabled },
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "save" } })],
                1
              ),
              _c(
                "w-toolbar-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-container",
        { staticClass: "w100", attrs: { "no-margin": "" } },
        [
          _vm.$wf.isMdUp
            ? _c(
                "w-breadcrumb",
                { attrs: { crumbs: _vm.path } },
                [
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      staticClass: "mr cancel",
                      attrs: { icon: "ban" },
                      on: {
                        click: function ($event) {
                          return _vm.cancel()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
                  ),
                  _c(
                    "w-button",
                    {
                      attrs: { disabled: _vm.saveDisabled, icon: "save" },
                      on: {
                        click: function ($event) {
                          return _vm.submit()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$ct("common.save")) + " ")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.loading
            ? _c(
                "w-row",
                { attrs: { grow: "", center: "" } },
                [
                  _c(
                    "w-col",
                    { attrs: { grow: "", center: "" } },
                    [_c("w-progress-circular")],
                    1
                  ),
                ],
                1
              )
            : !_vm.user.QuietMode
            ? _c(
                "w-scroll-view",
                { attrs: { tag: "w-container" } },
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c(
                            "w-card",
                            [
                              _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
                              _c(
                                "w-card-content",
                                [
                                  _c(
                                    "w-row",
                                    [
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12", md: "6" } },
                                        [
                                          _c("w-input", {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: _vm.userNameDissabled
                                                  ? _vm.$ct(
                                                      "tooltip.workspace-required-for-username"
                                                    )
                                                  : null,
                                                expression:
                                                  "userNameDissabled ? $ct('tooltip.workspace-required-for-username') : null",
                                              },
                                            ],
                                            attrs: {
                                              fancy: "",
                                              label: _vm.$ct("username"),
                                              disabled: _vm.userNameDissabled,
                                            },
                                            model: {
                                              value: _vm.inputs.username,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.inputs,
                                                  "username",
                                                  $$v
                                                )
                                              },
                                              expression: "inputs.username",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12", md: "6" } },
                                        [
                                          _c("w-input", {
                                            attrs: {
                                              fancy: "",
                                              label: _vm.$ct("email-address"),
                                              required: _vm.emailRequired,
                                              "has-error": _vm.hasError.email,
                                            },
                                            on: {
                                              blur: function ($event) {
                                                _vm.usedInputs.email = true
                                              },
                                            },
                                            model: {
                                              value: _vm.inputs.email,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.inputs,
                                                  "email",
                                                  $$v
                                                )
                                              },
                                              expression: "inputs.email",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12", md: "6" } },
                                        [
                                          _c("w-input", {
                                            attrs: {
                                              fancy: "",
                                              label: _vm.$ct("firstname"),
                                            },
                                            model: {
                                              value: _vm.inputs.firstName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.inputs,
                                                  "firstName",
                                                  $$v
                                                )
                                              },
                                              expression: "inputs.firstName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12", md: "6" } },
                                        [
                                          _c("w-input", {
                                            attrs: {
                                              fancy: "",
                                              label: _vm.$ct("lastname"),
                                            },
                                            model: {
                                              value: _vm.inputs.lastName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.inputs,
                                                  "lastName",
                                                  $$v
                                                )
                                              },
                                              expression: "inputs.lastName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12", md: "6" } },
                                        [
                                          _c("w-input", {
                                            attrs: {
                                              fancy: "",
                                              label: _vm.$ct("password"),
                                              password: "",
                                              required: _vm.passwordRequired,
                                              autocomplete: "new-password",
                                              "has-error":
                                                _vm.hasError.password,
                                            },
                                            on: {
                                              blur: function ($event) {
                                                _vm.usedInputs.password = true
                                              },
                                            },
                                            model: {
                                              value: _vm.inputs.password,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.inputs,
                                                  "password",
                                                  $$v
                                                )
                                              },
                                              expression: "inputs.password",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12", md: "6" } },
                                        [
                                          _c("w-input", {
                                            attrs: {
                                              fancy: "",
                                              label: _vm.$ct("repeat-password"),
                                              password: "",
                                              autocomplete: "new-password",
                                              "has-error":
                                                _vm.hasError.repeatPassword,
                                            },
                                            on: {
                                              blur: function ($event) {
                                                _vm.usedInputs.repeatPassword = true
                                              },
                                            },
                                            model: {
                                              value: _vm.inputs.repeatPassword,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.inputs,
                                                  "repeatPassword",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "inputs.repeatPassword",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c("w-col", { attrs: { xs: "12" } }, [
                                        _c("img", {
                                          staticClass: "profile-img",
                                          attrs: {
                                            src: _vm.profileImageUrl,
                                            alt: "Profile image",
                                          },
                                        }),
                                      ]),
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12" } },
                                        [
                                          _c(
                                            "w-link",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  _vm.changeProfilePictureModal = true
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$ct(
                                                      "change-profile-picture"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              !_vm.isOwner
                                ? _c("app-user-edit-ip-restriction", {
                                    attrs: { user: _vm.user },
                                  })
                                : _vm._e(),
                              _c(
                                "w-card-content",
                                [
                                  _c(
                                    "w-row",
                                    [
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12", md: "6" } },
                                        [
                                          _c("w-checkbox", {
                                            attrs: {
                                              label: _vm.$ct("dossier-access"),
                                            },
                                            model: {
                                              value: _vm.dossierAccess,
                                              callback: function ($$v) {
                                                _vm.dossierAccess = $$v
                                              },
                                              expression: "dossierAccess",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12", md: "6" } },
                                        _vm._l(
                                          _vm.formErrors,
                                          function (error, i) {
                                            return _c(
                                              "app-error-message",
                                              { key: i },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.$ct(error)) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.showPermissions
                    ? _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("app-permissions", {
                                attrs: {
                                  user: _vm.user,
                                  "buttons-only": _vm.isOwner,
                                },
                                model: {
                                  value: _vm.permissions,
                                  callback: function ($$v) {
                                    _vm.permissions = $$v
                                  },
                                  expression: "permissions",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.changeProfilePictureModal } },
        [
          _c("app-change-profile-picture", {
            attrs: { user: _vm.user },
            on: {
              input: function ($event) {
                return _vm.onNewProfilePicture($event)
              },
              close: function ($event) {
                _vm.changeProfilePictureModal = false
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }